import { Box, Button } from "@mui/material";
import type { FC } from "react";
import { INFER_TASK_STATUS_ENUM } from "../../../utils/constants";

type TaskActionsProps = {
  taskState: string;
  handleCancelClick: () => void;
  handleDeleteClick: () => void;
  handleReviewClick: () => void;
  isChosenTask?: boolean;
};

export const TaskActions: FC<TaskActionsProps> = ({
  taskState,
  handleCancelClick,
  handleDeleteClick,
  handleReviewClick,
  isChosenTask,
}) => (
  <Box
    sx={{
      display: "flex",
      justifyContent: "flex-end",
      alignItems: "center",
      height: "100%",
      gap: "8px",
    }}
  >
    <Button
      size="small"
      color={isChosenTask ? "success" : "warning"}
      onClick={handleCancelClick}
      disabled={taskState !== INFER_TASK_STATUS_ENUM.waiting}
      variant="outlined"
      sx={{
        fontWeight: 800,
        fontSize: "14px",
      }}
    >
      取消任务
    </Button>
    <Button
      size="small"
      color={isChosenTask ? "success" : "error"}
      onClick={handleDeleteClick}
      disabled={
        taskState === INFER_TASK_STATUS_ENUM.waiting ||
        taskState === INFER_TASK_STATUS_ENUM.inProgress
      }
      variant="contained"
      sx={{
        fontWeight: 800,
        fontSize: "14px",
      }}
    >
      删除任务
    </Button>
    <Button
      size="small"
      color={isChosenTask ? "success" : "primary"}
      onClick={handleReviewClick}
      disabled={taskState !== INFER_TASK_STATUS_ENUM.down}
      variant="outlined"
      sx={{
        fontWeight: 800,
        fontSize: "14px",
      }}
    >
      查看任务
    </Button>
  </Box>
);
